import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class SharedProvider {
    private dateAPIFormat: string = 'yyyy-MM-dd'; // API format
    private dateOutputFormat: string = 'dd/MM/yyyy'; // Show short format
    private dateOutputLongFormat: string = 'dd MMM yyyy'; // Show long format
    // outputMomentFormatDate: 'DD MMM YYYY' // 'dd MMM YYYY'

    setDateApiFormat(value: string) {
        this.dateAPIFormat = value;
    }

    setDateOutputFormat(value: string) {
        this.dateOutputFormat = value;
    }

    setDateOutputLongFormat(value: string) {
        this.dateOutputLongFormat = value;
    }

    get() {
        return {
            DateOutputLongFormat: this.dateOutputLongFormat,
            DateOutputFormat: this.dateOutputFormat,
            DateAPIFormat: this.dateAPIFormat
        };
    }
}



        //this.sharedProvider.setDateInputFormat(this.constants.inputFormatDate);
        //this.sharedProvider.setDateOutputFormat(this.constants.outputFormatDate);
        //this.sharedProvider.setDateOutputLongFormat(this.constants.outputFormatDateDMMMY);
